import { useCheckAuth } from '@app/auth/hooks/use-check-auth';
import { RefineThemedLayoutProps, ThemedLayoutContextProvider } from '@refinedev/antd';
import { Grid, Layout as AntdLayout } from 'antd';

import { Header as DefaultHeader } from './header';
import { ThemedSiderV2 as DefaultSider } from './sider';
import { UserCorruptedModal } from './user-corrupted-modal';

export const ThemedLayoutV2: React.FC<RefineThemedLayoutProps> = ({
  children,
  Header,
  Sider,
  Title,
  Footer,
  OffLayoutArea,
  initialSiderCollapsed,
}) => {
  const breakpoint = Grid.useBreakpoint();
  const SiderToRender = Sider ?? DefaultSider;
  const HeaderToRender = Header ?? DefaultHeader;
  const isSmall = typeof breakpoint.sm === 'undefined' ? true : breakpoint.sm;
  const hasSider = !!SiderToRender({ Title });

  const { userIsValid } = useCheckAuth({});

  return (
    <ThemedLayoutContextProvider initialSiderCollapsed={initialSiderCollapsed}>
      <AntdLayout hasSider={hasSider} style={{ height: '100vh', overflow: 'hidden' }}>
        <SiderToRender Title={Title} />
        <AntdLayout style={{ overflow: 'auto' }}>
          <HeaderToRender />
          <AntdLayout.Content>
            <div
              style={{
                minHeight: 360,
                padding: isSmall ? '32px 32px 24px 24px' : 12,
              }}
            >
              {userIsValid ? children : <UserCorruptedModal />}
            </div>
            {OffLayoutArea && <OffLayoutArea />}
          </AntdLayout.Content>
          {Footer && <Footer />}
        </AntdLayout>
      </AntdLayout>
    </ThemedLayoutContextProvider>
  );
};
